module.exports = __webpack_public_path__ + "img/apply_step.40b990cc.png";